import { Button } from 'antd'
import React from 'react'

const ButtonUC = (props) => {
    const { className, ...resProp } = props
    return (
        <>
            <Button
                className={'btn-uc-custom ' + className}
                {...resProp} />
        </>
    )
}

export default ButtonUC